export function compareSemver(a: string, b: string): number {
  const pa = String(a).split('.').map((n) => parseInt(n, 10));
  const pb = String(b).split('.').map((n) => parseInt(n, 10));
  for (let i = 0; i < 3; i += 1) {
    const d = (Number.isFinite(pa[i]) ? pa[i] : 0) - (Number.isFinite(pb[i]) ? pb[i] : 0);
    if (d !== 0) return d < 0 ? -1 : 1;
  }
  return 0;
}

export function newestVersion(file: { currentVersion?: string; releases: { version: string }[] }): string | null {
  const versions = [file.currentVersion, ...file.releases.map((release) => release.version)].filter(
    (version): version is string => !!version,
  );
  if (!versions.length) return null;
  return versions.slice().sort(compareSemver).pop() || null;
}
